import React from 'react';

import Logo from '../../uploads/Logo/EES Logo v2ees-logo.png';

export default function Feed() {
    const date = new Date();
    const year = date.getFullYear();

    return (
        <footer className="bg-gray-900 text-gray-300 py-12 mt-10">
            <div className="w-full max-w-screen-xl mx-auto px-6 md:px-12 lg:px-20">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-14">
                    
                    {/* Company Info */}
                    <div className="flex flex-col">
                        <p className="flex items-center space-x-3 mb-0 md:mb-4">
                            <img src={Logo} className="h-16" alt="EES Logo" />
                            <span className="text-xl font-semibold text-white">Energy Engineering Solutions</span>
                        </p>
                    </div>

                    {/* Navigation Links */}
                    <div>
                        <h3 className="text-lg font-semibold text-white mb-4">Навигација</h3>
                        <ul className="space-y-3">
                            <li>
                                <a href="/за-нас" className="hover:text-gray-100 transition">За нас</a>
                            </li>
                            <li>
                                <a href="/наши-проекти" className="hover:text-gray-100 transition">Наши проекти</a>
                            </li>
                            <li>
                                <a href="/contact" className="hover:text-gray-100 transition">Побарајте понуда</a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Information */}
                    <div className='text-wrap md:text-wrap' >
                        <h3 className="text-lg font-semibold text-white mb-4">Контакт</h3>
                        <p className="text-gray-400"><strong>ENERGY ENGINEERING SOLUTIONS DOO Skopje</strong></p>
                        <p className="text-gray-400">Ul. Filip II Makedonski br.3, DTC Soravia, 10 kat</p>
                        <p><a href="mailto:contact@ees.com.mk" className="text-indigo-400 hover:text-indigo-300 transition">contact@ees.com.mk</a></p>
                        <p><a href="tel:+38923126636" className="text-indigo-400 hover:text-indigo-300 transition">+389 23126636</a></p>
                    </div>
                </div>

                <hr className="my-8 border-gray-700" />

                <p className="text-center text-gray-400 text-sm">
                    © {year} Energy Engineering Solutions. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
}
